module.exports = __webpack_public_path__ + "img/Picture25.8e599dff.png";